export default __webpack_public_path__ + "static/media/comunidade.753642fe.png";